import React from "react";
import classNames from "classnames";

import styles from "./Layout.css";

export default function Content({ children, className }) {
  return (
    <main id="main" role="main" tabIndex="-1" className={classNames(styles.main, className)}>
      {children}
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/components/Library/Layout/Content.js